// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsAngle_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.82843 12.0012H1L11.3137 1.6875L12.7279 3.10171L11.1313 4.69835C12.901 6.4238 13.9999 8.83403 13.9999 11.5009C13.9999 12.0113 13.9597 12.5124 13.8821 13.001H16V15.001H3V13.001H11.8499C11.9483 12.5163 11.9999 12.0146 11.9999 11.5009C11.9999 9.38631 11.1248 7.4761 9.71693 6.11271L3.82843 12.0012Z" class="svg-bg"/>
  <path d="M0 15.001V13.001H2V15.001H0Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.8284 18H1.99997L18 2 19.4142 3.41421 16.7437 6.08473C19.138 8.74276 20.5954 12.2615 20.5954 16.1206 20.5954 17.4621 20.4192 18.7626 20.0889 20H24V22H4V20H18.0067C18.3892 18.7748 18.5953 17.4718 18.5953 16.1206 18.5953 12.8138 17.3607 9.79539 15.3272 7.50118L4.8284 18ZM0 20H2V22H0V20Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsAngle is a generated icon component.
 */
let IconAnnotationsAngle = IconAnnotationsAngle_1 = class IconAnnotationsAngle extends IconBaseElement {
    render() {
        return html `${IconAnnotationsAngle_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsAngle.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconAnnotationsAngle = IconAnnotationsAngle_1 = __decorate([
    customElement('zui-icon-annotations-angle')
], IconAnnotationsAngle);
export { IconAnnotationsAngle };
